export { AccountView } from '../views/Account/index.js'
export { CreateFirstUserView } from '../views/CreateFirstUser/index.js'
export {
  type DashboardViewClientProps,
  type DashboardViewServerProps,
  type DashboardViewServerPropsOnly,
  DefaultDashboard,
} from '../views/Dashboard/Default/index.js'
export { DashboardView } from '../views/Dashboard/index.js'

export { ListView, renderListView, type RenderListViewArgs } from '../views/List/index.js'
export { LoginView } from '../views/Login/index.js'
export { NotFoundPage } from '../views/NotFound/index.js'

export { type GenerateViewMetadata, RootPage } from '../views/Root/index.js'
export { generatePageMetadata } from '../views/Root/metadata.js'
